import React, {memo} from 'react';
import {AppMessage} from '~/components/elements/AppMessage';
import {
  Modal,
  ModalBody,
  ModalBodyProps,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react';
import {UiButton} from './UiButton';
import {UiHStack} from '~/components/elements/index';

interface Props extends ModalProps {
  headerTitle?: React.ReactNode;
  submitText?: string;
  closeText?: string;
  loading?: boolean;
  loadingContent?: boolean;
  isOpen: boolean;
  errors?: any;
  onClickSubmitBtn?: (e: React.FormEvent) => any;
  onClose: () => any;
  header?: React.ReactNode;
  actions?: React.ReactNode;
  hideSubmit?: boolean;
  contentMinW?: string;
  children: React.ReactNode;
  closeButtonSize?: any;
  isBottom?: boolean;
  modalBodyProps?: ModalBodyProps;
  hideCloseButton?: boolean;
}

export const AppModal = memo(function AppModal({
  isOpen,
  loading,
  loadingContent,
  headerTitle,
  closeText = 'Close',
  submitText = 'Submit',
  errors,
  onClickSubmitBtn,
  onClose,
  header,
  actions,
  hideSubmit,
  size = 'xl',
  contentMinW = '60%',
  children,
  isBottom,
  closeButtonSize = 'sm',
  modalBodyProps = {},
  hideCloseButton,
  ...rest
}: Props) {
  let styleContent = {};
  if (isBottom) {
    styleContent = {
      ...styleContent,
      marginTop: 'auto',
      marginBottom: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopRadius: 16,
    };
  }
  const renderHeader = () => {
    if (header) {
      return header;
    }
    if (header === null) {
      return null;
    }
    return <ModalHeader>{headerTitle}</ModalHeader>;
  };

  const renderActions = () => {
    if (actions) {
      return <>{actions}</>;
    }
    if (actions === null) {
      return null;
    }
    return (
      <UiHStack>
        {!hideSubmit && (
          <UiButton onClick={onClickSubmitBtn} isLoading={loading}>
            {submitText}
          </UiButton>
        )}
        <UiButton variant="outline" onClick={onClose}>
          {closeText}
        </UiButton>
      </UiHStack>
    );
  };

  return (
    <>
      <Modal onClose={onClose} size={size} isOpen={isOpen} scrollBehavior="inside" {...rest}>
        <ModalOverlay />
        <ModalContent minW={contentMinW} {...styleContent}>
          {renderHeader()}
          {!hideCloseButton && <ModalCloseButton size={closeButtonSize} />}
          <ModalBody {...modalBodyProps}>
            <AppMessage type="error" body={errors} />
            {children}
          </ModalBody>

          <ModalFooter>{renderActions()}</ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
